import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function FetchEmployeeOffboardingMembersService(token, data) {
    return axios.post(`${CURRENT_API_URL}/account/fetchEmployeeOffboardingMembers`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        return res.data;
    }).catch(error => {
        console.log(error)
        notify.NotifyError("An error occurred while fetching employees, please try again later.");
        return false;
    });
}
export default FetchEmployeeOffboardingMembersService
